import { Button } from "@shared/ui/chakra/buttons/button";

type ResendButtonProps = {
  disabled: boolean;
  label: string;
  isLoading?: boolean;
  onClick: () => void;
};

export const ResendButton = ({
  disabled,
  label,
  isLoading,
  onClick,
}: ResendButtonProps) => (
  <Button
    disabled={disabled}
    loading={isLoading}
    variant="plain"
    onClick={onClick}
  >
    {label}
  </Button>
);
